// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { CreditMethod } from '../../types/Model';

import { ExamInformation } from '../../types/Model';
export interface BuyExamRequestPayload {
  id: number;
  test?: boolean;
  workshopId?: number;
  creditMethod?: CreditMethod;
  success?: () => void;
  onError?: (error:string) => void;
}
export interface BuyExamSuccessPayload {
  examInformation: ExamInformation;
}

export interface BuyExamFailPayload {
  error: Error;
}

export const buyExamActions = createAsyncAction(
  'elearning/BUY_EXAM',
  'elearning/BUY_EXAM_SUCCESS',
  'elearning/BUY_EXAM_FAIL'
)<
  BuyExamRequestPayload,
  BuyExamSuccessPayload,
  BuyExamFailPayload
>();
